import { Project } from '@bulthaup/api/db';
import { Button, Group, Text } from '@mantine/core';

import { useBooleanButtonState } from './-hooks/-use-boolean-button-state';

export function CustomerNotificationSection({ project }: { project: Project }) {
  const field = 'isCustomerNotifiedOfInstallationDate';
  const { isFieldPending, toggleBooleanState } = useBooleanButtonState<
    typeof field
  >({
    project,
    fieldConfigs: {
      isCustomerNotifiedOfInstallationDate: {
        successMessage: 'État client/archi mis à jour',
        getBlockingCondition: currentProject => {
          if (!currentProject.deliveryDate) {
            return {
              title: "Avant d'informer le client / l'archi vous devez:",
              requirements: ['Documenter la date de livraison'],
            };
          }

          return null;
        },
      },
    },
  });

  const isCustomerNotified = project.isCustomerNotifiedOfInstallationDate;

  const onToggleCustomerNotified = () => {
    void toggleBooleanState(field, isCustomerNotified);
  };

  return (
    <Group justify="space-between" wrap="nowrap" align="flex-start">
      <Text style={{ flex: 1, minWidth: 0 }}>
        Client et archi informés de la date de pose
      </Text>
      <Button
        color={isCustomerNotified ? 'green' : 'red'}
        variant="filled"
        onClick={onToggleCustomerNotified}
        disabled={isFieldPending(field)}
        loading={isFieldPending(field)}
        style={{ flexShrink: 0 }}
      >
        {isCustomerNotified ? 'OUI' : 'NON'}
      </Button>
    </Group>
  );
}
